import { CommonUtilities } from 'commonUtils';
import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function PerformerUpsert(param: any) {

    let [savedStatus, setSavedStatus] = useState(true);
    let [filterSelection, SetFilterSelection] = useState<any>([]);

    const onCloseDrawer = () => {

        console.log(filterSelection)

        if (savedStatus == false) {
            CommonUtilities.showToastDawer('Some data unsave', 'fail')
        } else {
            param.PerformersUpsertChange();
        }

    }

    useEffect(() => {

        
        filterSelection = param?.PerformerSelected ?? [];

        console.log(param?.PerformerSelected)
        SetFilterSelection(filterSelection)
        const handleEsc = (e: any) => {
            if (e.key === 'Escape') {
                onCloseDrawer();
            }
        };

        document.addEventListener('keydown', handleEsc);

        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
        

    }, [onCloseDrawer]);

    const saveChange = () => {

        savedStatus = true;
        setSavedStatus(savedStatus)
        CommonUtilities.showToastDawer('Production Saved', 'Success')
    }

    return (
        <Drawer open={param.PerformerUpsertOpen}
            onClose={onCloseDrawer}
            direction='right'
            className='react-drawer  allowHscroll allowVscroll'
            size={800}>

            <div className="box noBorderRadius noBorder ws-4 pull-right full-height-vh">

                <div className='ws-12 pm'  >

                    <div className='ws-10'>
                        <h1 className='text-bold'> Create New Performer</h1>
                        <span className=' ptl'>Add New Performer.</span>
                    </div>

                    <button onClick={() => onCloseDrawer()} className="btn-xxs  borderNone bgTransparent pull-right mtxl"  >
                        <i className="icon-close3 danger"></i>
                    </button>
                </div>

                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                <div className='ws-11 paddingCenterBox pLarge '>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Performer Name *</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, displayName: e.target.value, }); setSavedStatus(false) }} value={filterSelection?.displayName ?? ""}/>
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Alternate / Credited Name</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, productionType: e.target.value, }); setSavedStatus(false) }} />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold'>BECS Membership Status</label>

                        <div className='ws-12 pm'>
                            <label className='ws-12 ps'>
                                <input type="radio" name="source" onChange={(e) => { SetFilterSelection({ ...filterSelection, Status: e.target.value, }); setSavedStatus(false) }} checked={filterSelection?.Status == "member" ? true : false}/>
                                BECS Member
                            </label>

                            <label className='ws-12 ps'>
                                <input type="radio" name="source" onChange={(e) => { SetFilterSelection({ ...filterSelection, Status: e.target.value, }); setSavedStatus(false) }} checked={filterSelection?.Status == "non-member" ? true : false}/>
                                Not a member
                            </label>

                            <label className='ws-12 ps'>
                                <input type="radio" name="source" onChange={(e) => { SetFilterSelection({ ...filterSelection, Status: e.target.value, }); setSavedStatus(false) }} checked={filterSelection?.Status == "unverified" ? true : false}/>
                                Unknown
                            </label>
                        </div>
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'>BECS Member ID</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, productionType: e.target.value, }); setSavedStatus(false) }} value={filterSelection?.memberID ?? ""}/>
                    </div>
                </div>


                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                <div className='ws-12 pm'>
                    <h2 className='ws-10 text-bold grey'>Notes (optional)</h2>
                    <textarea className='width450' placeholder='Internal notes only. Not visible in casts.'></textarea>
                </div>

                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                <div className='ws-12 pm'>
                    <button type="button" className=" icon-btn close text-bold pull-left height40 width100" onClick={() => onCloseDrawer()}>Close</button>
                    <button type="button" className=" icon-btn edit  text-bold pull-right height40 width150" onClick={() => saveChange()}>Save</button>
                </div>

            </div>

        </Drawer>

    )
}